import React from 'react';
import sc from 'styled-components';
import {DatePicker, Dialog, Layout} from '@phonectas/unifon-ui-kit';

interface StyledDialogProps {
    $width?: number;
    $noOverflow?: boolean;
	$noGap?: boolean;
}

interface StyledDialogBodyProps  extends React.HTMLAttributes<HTMLDivElement> {
    $noOverflow?: boolean;
	$noGap?: boolean;
}

export const StyledDialog = sc(Dialog)<StyledDialogProps>`
	width: ${({$width}) => typeof $width === 'number' ? `${$width}px` : '690px'};
	max-height: 80vh;
	flex-wrap: nowrap;
	padding: 16px;
	overflow: ${({$noOverflow}) => $noOverflow ? 'hidden' : 'auto'};
	row-gap: ${({$noGap}) => $noGap ? '0' : '8px'};
	column-gap: ${({$noGap}) => $noGap ? '0' : '8px'};
`;

export const StyledDialogBody = sc(Layout)<StyledDialogBodyProps>`
	padding: 3px 2px;
	overflow: ${({$noOverflow}) => $noOverflow ? 'hidden' : 'auto'};
	row-gap: ${({$noGap}) => $noGap ? '0' : '8px'};
	column-gap: ${({$noGap}) => $noGap ? '0' : '8px'};
`;

export const StyledSimCardGrid = sc.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(296.69px, 300px));
	grid-gap: 5px;
	max-width: 100%;
	width: 100%;
`;

export const StyledDatePicker = sc(DatePicker)`
	box-shadow: none;
	border-radius: 4px;
	border: 1px solid #E4E7EB;
`;

export const StyledTableFilterRow = sc(Layout)`
	flex-direction: row;
	align-items: center;
	width: 100%;
	max-height: 30px;
	flex-wrap: nowrap;
	overflow: hidden;
`;

